/** @jsxImportSource @emotion/react */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import {range, size} from 'lodash'
import { jsx, css } from '@emotion/react'
import { Trans } from 'react-i18next'
import { catch_errors } from '../lib'
import { default_theme as theme } from '../emotion/theme'
import { updateListPagination, invalidateList, getPagination } from '../orm/orm_list_actions'
import { Pagination as BootstrapPagination } from 'react-bootstrap'
import { Row, Col, Button } from 'react-bootstrap'
import { InlineIcon } from './layout/InlineIcon'
import { faCaretRight, faCaretLeft } from '@fortawesome/free-solid-svg-icons'
import { DropdownStandalone } from './form/Dropdown'

const ITEMS_PER_PAGE_OPTIONS = [
    {value: 10, label: '10'},
    {value: 20, label: '20'},
    {value: 50, label: '50'},
    {value: 100, label: '100'}
]

class Pagination extends Component {

    refresh = () => {
        const { item_list, dispatch } = this.props
        dispatch(item_list.invalidateList())
        dispatch(item_list.fetchListIfNeeded())
    }

    gotoPage(number) {
        const { dispatch, listKey, filters, onChange, item_list } = this.props
        dispatch(updateListPagination(listKey, {page: number}))
        dispatch(invalidateList(listKey))
        if ( item_list ) {
            dispatch(item_list.fetchListIfNeeded())
        }
        if (onChange) {
            onChange(number)
        }
    }

    onSelectItemsPerPage = (value) => {
        const { dispatch, item_list } = this.props
        dispatch(item_list.updatePaginationNumItemsPerPage(value))
        dispatch(item_list.invalidateList())
        dispatch(item_list.fetchListIfNeeded())
    }

    renderButton({label, onClick, active, index, first_number_index, last_number_index, extra_css}) {
        return (
            <div css={[pagination_item,
                       (active && pagination_item__active) || pagination_item__inactive,
                       (index === first_number_index && pagination_left) || null,
                       (index === last_number_index && pagination_right) || null,
                       extra_css || null]}
                 key={index}
                 onClick={onClick}>
              {label}
            </div>
        )
    }

    renderPageNumber(number, index, range_args) {
        const {current_page, prev_page, next_page, num_pages } = this.props
        switch (number) {
            case current_page:
                return (
                    this.renderButton({label:number, onClick:() => this.gotoPage(number), active:true, index, ...range_args})
                )
            case 'first':
                return (
                    this.renderButton({label:1, onClick:() => this.gotoPage(1), active:false, index, ...range_args, extra_css: pagination_isolated})
                )
            case 'last':
                return (
                    this.renderButton({label:num_pages, onClick:() => this.gotoPage(num_pages), active:false, index, ...range_args, extra_css: pagination_isolated})
                )
            case 'prev':
                return (
                    this.renderButton({label:( <InlineIcon icon_name="caret-left" />),
                                       onClick:() => this.gotoPage(prev_page), active:false, index, ...range_args, extra_css: pagination_isolated})
                )
            case 'next':
                return (
                    this.renderButton({label:(<InlineIcon icon_name="caret-right" />),
                                       onClick:() => this.gotoPage(next_page), active:false, index, ...range_args, extra_css: pagination_isolated})
                )
            case 'splitter':
                return (
                    <div key={index}>
                      ...
                    </div>
                )
            default:
                return (
                    this.renderButton({label:number, onClick:() => this.gotoPage(number), active:false, index, ...range_args})
                )
        }
    }

    renderItemsPerPage() {
        const { item_list, items_per_page } = this.props
        return (
            <div css={items_per_page_style}>
              { item_list && 
                <DropdownStandalone default_value={items_per_page}
                                    options={ITEMS_PER_PAGE_OPTIONS}
                                    value={items_per_page}
                                    variant="bootstrap"
                                    on_change={this.onSelectItemsPerPage}/>
              }
            </div>
        )
    }

    renderPageNumbers() {
        const { num_pages, current_page} = this.props
        
        const adjacents = 3

        let numbers = []

        // numbers.push('first')
        numbers.push('prev')
        
        if (num_pages < 7 + (adjacents * 2)) {
            numbers = numbers.concat(range(1, num_pages + 1))
        } else if (num_pages > 5 + (adjacents * 2)) {
            if (current_page < 1 + (adjacents * 2)) {
                // close to beginning; only hide later pages
                numbers = numbers.concat([...range(1, 4 + (adjacents * 2)), 'splitter', num_pages -1, num_pages])
            } else if ((num_pages - (adjacents * 2) > current_page) && (current_page > (adjacents * 2))) {
                // in middle; hide some front and some back
                numbers = numbers.concat([
                    1, 2, 'splitter',
                    ...range(current_page - adjacents, current_page + adjacents + 1),
                    'splitter',
                    num_pages])
            } else {
                // close to the end, hide early pages
                numbers = numbers.concat([1, 2, ...range(num_pages - (2+(adjacents * 2)), num_pages)], num_pages)
            }
        }
        numbers.push('next')
        // numbers.push('last')
        const first_number_index = 1
        const last_number_index = size(numbers)-2
        return numbers.map((number, index) => this.renderPageNumber(number, index, {first_number_index, last_number_index}))
    }

    render() {
        const {num_pages, item_list} = this.props

        return (
            <div css={pagination_container}>
              <Row>
                <Col>
                  <div css={action_buttons_style}>
                    { item_list &&
                      (
                          <div css={pagination_group}>
                            <div css={[pagination_item, refresh_button]} onClick={() => this.refresh()}>
                              <Trans>Refresh</Trans>
                            </div>
                          </div>
                      )
                    }
                    {this.renderItemsPerPage()}
                  </div>
                </Col>
                <Col>
                  <div css={page_numbers_style}>
                    {this.renderPageNumbers()}
                  </div>
                </Col>
              </Row>
            </div>
        )
    }
}

function mapStateToProps(state, props) {
    const pagination = getPagination(props.listKey, state)
    const { item_list, listKey } = props

    return {
        listKey,
        item_list,
        min_page_num: 1,
        current_page: pagination.current_page || 1,
        num_pages: pagination.num_pages || 0,
        num_items: pagination.num_items || 0,
        first_item_index: pagination.first_item_index || 1,
        last_item_index: pagination.last_item_index || 1,
        next_page: pagination.next_page,
        prev_page: pagination.prev_page,
        items_per_page: pagination.items_per_page
    }
}

export default connect(catch_errors(mapStateToProps))(Pagination)

const pagination_container = css`
display: flex;
justify-content: left;
margin-top: 20px;
margin-bottom: 20px;
`

const refresh_button = css`
margin-right: 15p;
border-radius: 4px;
text-align: center;
`

const pagination_group = css`
margin-right: 15px;
`

const pagination_isolated = css`
margin-right: 4px;
margin-left: 4px;
border-radius: 4px;
`

const pagination_left = css`
border-top-left-radius: 4px;
border-bottom-left-radius: 4px;
`

const pagination_right = css`
border-top-right-radius: 4px;
border-bottom-right-radius: 4px;
`

const pagination_item = css`
color: #000;
background-color: #ffffff;
border: 1px solid #d1d1d6;
line-height: 18px;
padding: 10px;
cursor: pointer;

&:first {
border-radius: 4px;
}

&:last {
border-radius: 4px;
}

&:hover {
background-color: #efeff4;
}

`


const pagination_item__inactive = css`

`

const pagination_item__active = css`
background-color: #efeff4;
`

const items_per_page_style = css`
width: 75px;
`

const page_numbers_style = css`
display: flex;
`

const action_buttons_style = css`
display: flex;
margin-bottom: 20px;
`
 
